// @flow
import { injectIntl } from 'react-intl';
import SnippetCars from './component';

const SnippetCarsContainer = injectIntl(SnippetCars);

SnippetCarsContainer.displayName = 'SnippetCarsContainer';

export default SnippetCarsContainer;



// WEBPACK FOOTER //
// ./app/common/Snippet/cars/container.js